import { render, staticRenderFns } from "./product.vue?vue&type=template&id=51a0c25e&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=51a0c25e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0c25e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51a0c25e')) {
      api.createRecord('51a0c25e', component.options)
    } else {
      api.reload('51a0c25e', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=51a0c25e&scoped=true", function () {
      api.rerender('51a0c25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/contractManage/contractFrom/product.vue"
export default component.exports